import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SettingsLayout from '../../components/layout/SettingsLayout';
import UserProfileSettingsImproved from './UserProfileSettingsImproved';
import UserPreferences from './UserPreferences';
import AutomationSettingsPage from './AutomationSettingsPage';
import UserSecuritySettings from './UserSecuritySettings';
import ValidationIssueSettings from './ValidationIssueSettings';
import ApiKeysPage from './ApiKeysPage';
import BillingSettings from './BillingSettings';
import { useUI } from '../../contexts/UIContext';

const UserSettingsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { updateBreadcrumbs } = useUI();

  // Determine active tab from URL path
  const getActiveTabFromPath = useCallback(() => {
    const path = location.pathname;
    if (path.includes('/billing')) return 'billing';
    if (path.includes('/automation')) return 'automation';
    if (path.includes('/validation-issues')) return 'validation-issues';
    if (path.includes('/preferences')) return 'preferences';
    if (path.includes('/security')) return 'security';
    if (path.includes('/api-keys')) return 'api-keys';
    return 'profile';
  }, [location.pathname]);

  const [activeTab, setActiveTab] = useState(getActiveTabFromPath());

  // Update active tab when location changes
  useEffect(() => {
    setActiveTab(getActiveTabFromPath());
  }, [getActiveTabFromPath]);

  // Clear breadcrumbs when the page loads to use path-based breadcrumbs
  useEffect(() => {
    updateBreadcrumbs([]);
  }, [updateBreadcrumbs]);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);

    // Update URL to match the tab
    const basePath = '/settings';
    const newPath = tabId === 'profile' ? basePath : `${basePath}/${tabId}`;
    navigate(newPath, { replace: true });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'billing':
        return <BillingSettings />;
      case 'automation':
        return <AutomationSettingsPage />;
      case 'validation-issues':
        return <ValidationIssueSettings />;
      case 'preferences':
        return <UserPreferences />;
      case 'security':
        return <UserSecuritySettings />;
      case 'api-keys':
        return <ApiKeysPage />;
      case 'profile':
      default:
        return <UserProfileSettingsImproved />;
    }
  };

  return (
    <SettingsLayout activeTab={activeTab} onTabChange={handleTabChange}>
      {renderTabContent()}
    </SettingsLayout>
  );
};

export default UserSettingsPage;